import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import PlanoInspecaoService from "service/qualidade/PlanoInspecaoService";
import { ListMatchModeOptions, TextMatchModeOptions, filterApplyTemplate } from "utils/filterUtils";

const planoInspecaoService = new PlanoInspecaoService();

export default function PlanoInspecaoListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Planos de inspeção');

    const defaultFilters: DataTableFilterMeta = {
        codigoInterno: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },

        nome: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },

        descricao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },

        fase: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    const faseFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <MultiSelect value={options.value} options={planoInspecaoService.getFaseFilter()}
            onChange={(e: MultiSelectChangeEvent) => options.filterCallback(e.value)}
            optionLabel="label" optionValue="value" placeholder="Qualquer" className="p-column-filter"
        />;
    };

    return (

        <BaseListagem ordenacao="codigoInterno,ASC" service={planoInspecaoService} urlService="/planoInspecao" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="planoInspecao">
            <Column 
                field="codigoInterno" header="Código" 
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterPlaceholder="Escreva o filtro"
            />
            <Column 
                field="nome" header="Nome"   
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterPlaceholder="Escreva o filtro"
            />
            <Column 
                field="descricao" header="Descrição" 
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterPlaceholder="Escreva o filtro"
            />
            <Column 
                field="fase" header="Fase" body={(rowData)=>planoInspecaoService.getFase(rowData.fase)} 
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate} filterElement={faseFilterTemplate}
            />
        </BaseListagem>
    )
}